import PageDashboardEM from "./pages/PageDashboardEM.vue"
import PageDashboardIot from "./pages/PageDashboardIot.vue"
import { registerEnergyManagerDashboardMessages } from "./utils/i18n"
import { RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"

// ====================================
// Module Energy Manager - Routes
// ====================================
// Routes fiche bâtiment / source : modules/energy-manager/building.routes.ts, @core/router/source.routes.ts

/**
 * Au rechargement, les données user (companyId, subscription) peuvent ne pas être
 * encore chargées ; les récupérer avant les vérifications d'offre / modules.
 */
async function ensureAuthUserLoaded(
    authStore: ReturnType<typeof useAuthStore>
): Promise<void> {
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
}

export const routes = [
    {
        path: "/energy-manager/dashboard",
        name: "PageDashboardEM",
        component: PageDashboardEM,
        // ajoute un middleware pour vérifier si l'utilisateur est connecté
        meta: {
            requiresAuth: true,
            layout: "header",
        },
        beforeEnter: async (_to, _from, next) => {
            registerEnergyManagerDashboardMessages()
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (authStore.hasOfferEnergyManager) {
                next()
            } else {
                next({ path: "/building" })
            }
        },
    },
    {
        path: "/energy-manager/dashboard/iot",
        name: "PageDashboardIot",
        component: PageDashboardIot,
        meta: { requiresAuth: true, layout: "header" },
        beforeEnter: async (_to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (
                authStore.hasModuleExploitantChauffagiste &&
                authStore.isEmployeWriteOrHigher
            ) {
                next()
            } else {
                next({ path: "/building" })
            }
        },
    },
] as RouteRecordRaw[]
